import React, { useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import WeeklyTable from './weeklyTable';

const RotaTable = () => {
  const [table, setTable] = useState('Weekly');

  const users = [
    { name: 'Ali Hassan', code: 'AH' },
    { name: 'Ayesha Malik', code: 'AM' },
    { name: 'Zainab Khan', code: 'ZK' },
    { name: 'Omar Farooq', code: 'OF' },
  ];

  const getUserColor = (code) => {
    const colors = {
      AH: 'bg-blue-100 text-blue-700 border-blue-200',
      AM: 'bg-rose-100 text-rose-700 border-rose-200',
      ZK: 'bg-amber-100 text-amber-700 border-amber-200',
      OF: 'bg-purple-100 text-purple-700 border-purple-200',
    };
    return colors[code] || 'bg-slate-100 text-slate-700 border-slate-200';
  };

  const getDateRangeText = () => {
    switch (table) {
      case 'Daily':
        return 'Today: June 30, 2026';
      case 'Weekly':
        return 'Weekly view: June 29 - July 4, 2026';
      case 'Monthly':
        return 'Month: June 2026';
      default:
        return 'June 2026';
    }
  };

  return (
    <section className="mx-auto mt-8 max-w-7xl rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
      <div className="flex flex-col justify-between gap-6 border-b border-slate-100 pb-6 lg:flex-row lg:items-center">
        <div>
          <h2 className="text-xl font-bold text-slate-800">Rota Schedule</h2>
          <div className="mt-1 flex w-fit items-center gap-2 rounded-lg border border-blue-100/50 bg-blue-50/70 px-3 py-1 text-sm font-semibold text-blue-600">
            <FaCalendarAlt className="h-3.5 w-3.5 shrink-0" />
            <span>{getDateRangeText()}</span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <select
            id="view-filter"
            value={table}
            onChange={(event) => setTable(event.target.value)}
            className="block cursor-pointer rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition-all focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {['Daily', 'Weekly', 'Monthly'].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-6">
        <h3 className="mb-3 text-xs font-bold uppercase tracking-wider text-slate-400">
          Scheduled Team Members ({users.length})
        </h3>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {users.map((user) => {
            const colorClass = getUserColor(user.code);
            return (
              <div
                key={user.code}
                className="flex items-center gap-3 rounded-xl border border-slate-100 bg-slate-50/50 p-3 transition-colors hover:bg-slate-50"
              >
                <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border text-xs font-bold shadow-inner ${colorClass}`}>
                  {user.code}
                </div>
                <div className="truncate">
                  <p className="truncate text-sm font-semibold text-slate-700">{user.name}</p>
                  <p className="text-[11px] font-medium text-slate-400">Team Member</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {table === 'Weekly' ? (
        <WeeklyTable />
      ) : (
        <div className="mt-6 rounded-2xl border border-dashed border-slate-200 bg-slate-50/30 p-12 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-slate-500 shadow-sm">
            <FaCalendarAlt className="h-5 w-5" />
          </div>
          <p className="mt-4 text-sm font-semibold text-slate-600">{table} view is not wired yet</p>
          <p className="mt-1 text-xs text-slate-400">Switch to the weekly view to see the full rota matrix.</p>
        </div>
      )}
    </section>
  );
};

export default RotaTable;
